export class ResponseError extends Error {
    status;
    method;
    requestUrl;
    error;
    constructor(opts) {
        const { status, method, url, error } = opts;
        super(`Request failed with status ${status}: ${method} ${url}${typeof error === 'string' ? ` - ${error}` : ''}`);
        this.status = status;
        this.method = method;
        this.requestUrl = new URL(url);
        this.error = error;
    }
    get pathname() {
        return this.requestUrl.pathname;
    }
    get formErrors() {
        return Object.entries(this.error).reduce((errors, [key, value]) => {
            errors[key] = [{ message: value }];
            return errors;
        }, {});
    }
    isUnauthorized() {
        return this.status === 401;
    }
    isFormError() {
        return this.status === 422;
    }
    isServerError() {
        return this.status >= 500;
    }
    isNotFoundError() {
        return this.status === 404;
    }
}
